'use client'

import gsap                       from 'gsap'
import SplitText                  from 'gsap/SplitText'
import React, {useEffect, useRef} from 'react'
import styles                     from './memorable.module.scss'

const MOVING_RIGHT_DURATION = .5

gsap.registerPlugin(SplitText)

const Memorable = ({memorable}) => {
	const memorableContainerRef = useRef(null)
	const movingRightRef        = useRef(null)
	const experienceRef         = useRef(null)

	useEffect(() => {
		const splitText = new SplitText(experienceRef.current, {type: 'chars'})
		gsap.timeline({
				scrollTrigger: {
					trigger: memorableContainerRef.current,
					start:   'top top',
					end:     '+=0',
					once:    true,
				},
			})
			.call(() => {
				experienceRef.current && (experienceRef.current.inert = false)
				movingRightRef.current && (movingRightRef.current.inert = false)
			}, undefined, '>')
			.fromTo(splitText.chars, {
				opacity:  0,
				yPercent: -100,
			}, {
				opacity:    1,
				yPercent:   0,
				stagger:    .02,
				duration:   .2,
				clearProps: 'all',
			}, MOVING_RIGHT_DURATION).call(() => {
			splitText.revert()
		}, undefined, '>')
	}, [])

	return (<div
		ref={memorableContainerRef}
		className={styles['memorable']}
		style={{
			'--moving-right-duration': `${MOVING_RIGHT_DURATION}s`,
		}}
	>
		<h2
			className={styles[`memorable__title`]}
			aria-label={`${memorable.texts.map(t => t.text).join(' ')}`}
		>
			<p>{memorable.texts[0].text}</p>
			<div>
				<div
					className={styles['memorable__moving-right']}
					ref={movingRightRef}
					inert
				>
					<span>{memorable.texts[1].text}</span>
				</div>
				<div
					className={styles[`memorable__experience`]}
					ref={experienceRef}
					inert
				>{memorable.texts[2].text}</div>
			</div>
		</h2>
	</div>)
}

export default Memorable
